import Image from 'components/Image';
import { usePhotoGalleryContainer } from '..';
import styles from './styles/PhotoGalleryModalThumbnails.module.scss';

export default function PhotoGalleryModalThumbnails() {
  const [{ thumbnailsToShow, currentIndex, start }, { handleChangeIndex, isPhoto }] = usePhotoGalleryContainer();

  return (
    <div className={styles.Thumbnails}>
      {thumbnailsToShow.map((image, index) => {
        const thumbnailIndex = start + index;
        const thumb = isPhoto(image) ? (
          <Image
            key={`modal-thumbnail-${thumbnailIndex}`}
            src={image.s3Watermark ?? image.watermark}
            alt={image.filename}
            onClick={() => handleChangeIndex(thumbnailIndex)}
            className={currentIndex === thumbnailIndex ? styles.Active : styles.Inactive}
          />
        ) : (
          <div className={styles.Ad} key={`modal-thumbnail-ad`}>
            AD
          </div>
        );
        return thumb;
      })}
    </div>
  );
}
